import clsx from "clsx";
import { CSSProperties } from "react";
import styles from "./divider.module.scss";

type Props = {
  className?: string;
  style?: CSSProperties;
};

const Divider = ({ className, style }: Props) => (
  <div style={style} className={clsx(styles.divider, className)} />
);

export default Divider;
